import { render, staticRenderFns } from "./data-table.vue?vue&type=template&id=02c4dc2f&scoped=true"
import script from "./data-table.vue?vue&type=script&lang=js"
export * from "./data-table.vue?vue&type=script&lang=js"
import style0 from "./data-table.vue?vue&type=style&index=0&id=02c4dc2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c4dc2f",
  null
  
)

export default component.exports